import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AuthStoreService } from 'src/app/shared/services/auth/auth-store.service';
import { AuthApiService } from 'src/app/shared/services/auth/auth.api.service';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { EmailVerificationService } from '../../../shared/services/auth/email-verification.service';
import { EmailTokenVerificationStatus } from '../../model/email-verification-token.model';
import { RegistrationService } from '../../../shared/services/auth/registration.service';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-email-verification-token',
  styleUrls: ['./email-verification-token.component.scss'],
  templateUrl: './email-verification-token.component.html',
})
export class EmailVerificationTokenComponent implements OnInit {
  public verificationStatus = EmailTokenVerificationStatus;
  public verificationStatus$: Observable<EmailTokenVerificationStatus>;
  public email: string;

  constructor(
    private route: ActivatedRoute,
    private analytics: AnalyticsService,
    public authStore: AuthStoreService,
    private authApiService: AuthApiService,
    private emailVerificationService: EmailVerificationService,
    private registrationService: RegistrationService,
  ) {}

  public ngOnInit(): void {
    this.analytics.trackEvent(new AnalyticsEvent('Customer Email Address Token Verification Started'));
    const verificationToken = this.route.snapshot.paramMap.get('verificationToken') || '';
    this.verifyEmail(verificationToken);
  }

  public verifyEmail(verificationToken: string): void {
    this.verificationStatus$ = this.authApiService
      .verifyEmailToken({
        verificationState: verificationToken,
      })
      .pipe(
        tap((email) => {
          this.email = email.email;
          this.trackVerificationCompletedEvents();
        }),
        map(() => EmailTokenVerificationStatus.VERIFIED),
        catchError(() => of(EmailTokenVerificationStatus.REJECTED)),
      );
  }

  public goToApp(): void {
    this.emailVerificationService.redirectAfterEmailVerification();
  }

  private trackVerificationCompletedEvents(): void {
    this.analytics.trackLogin();
    this.analytics.trackEvent(new AnalyticsEvent('Customer Email Address Token Verification Completed'));
    this.registrationService.trackRegistrationEvent('Customer Registration Completed');
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
